export default {
  process: {
    step1: '背景と道路',
    step2: 'レイアウト要素',
    step3: '出口を設定',
    next: '次へ',
    previous: '前へ',
    finish: '完了',
    nextWarning: 'レイアウト領域に要素を配置してください。',
  },
  tool: {
    select: '選択済み',
    erase: '消去',
    selectTip:
      'レイアウトエリアでクリックまたはドラッグして必要なグリッドを選択し、エリアを配置してください。',
  },
  step1Editor: {
    edit1: {
      title: 'グリッドを設定',
      rowColumnNum: '行と列',
      row: '行',
      column: '列',
      gridSize: 'グリッドサイズ',
    },
    edit2: {
      title: '背景を設定',
      size: '寸法',
      sizeScreenSplit: '[サイズ]パラメーター横縦分割',
    },
    edit3: {
      title: '道路を設定',
      chooseRoad: '道路を選択',
      chooseArea: 'エリアを選択',
      rules: 'エレメントの配置ルール',
      onRoad: 'エレメントは道路上にのみ配置可能',
      notOnRoad: 'エレメントは道路上に配置不可',
      area: 'エリア',
    },
  },
  step2Editor: {
    edit1: {
      title: '移動方向',
      titleTip:
        '有効にすると、要素の移動方向を以下の5つの方向から選択できます。',
      uploadForward: '直線矢印をアップロードしてください',
      uploadTurnLeft: '左転回矢印をアップロードしてください',
      uploadTurnRight: '右転回の矢印をアップロードしてください',
      uploadLeft: '左折矢印をアップロードしてください',
      uploadRight: '右折矢印をアップロードしてください',
      Forward: '直進矢印',
      TurnLeft: '左転回矢印',
      TurnRight: '右転回矢印',
      Left: '左折矢印',
      Right: '右折矢印',
      setting: {
        title: '外観',
        applyToAll: 'すべての矢印に適用する',
      },
    },
    edit2: {
      title: 'メイン要素を設定',
      elementTip:
        '操作中に要素を有効にするかどうかを判断します。 無効にすると、要素は無効になります。',
      gridNum: 'グリッドの占有数',
      pivot: '矢印アンカー',
      pivotDesc:
        '緑の点は矢印の中心です。 緑の点を移動して矢印が表示される位置を調整できます。',
    },
    edit3: {
      title: '障害物タイプを設定',
    },
    addCustomEleType: 'カスタム要素タイプを追加',
    customEle: {
      eleName: 'カスタム要素のカテゴリ',
      dialog: {
        title: 'カスタム要素タイプの管理',
      },
    },
    addGroupDialog: {
      mainTitle: 'メイン要素カテゴリを追加',
      obsTitle: '障害物タイプを追加',
      customTitle: 'カスタム要素のカテゴリを追加',
      categoryName: 'カテゴリ名',
      gridNum: '占有されたグリッド',
      categoryNamePlaceholder: 'カテゴリ名を入力してください',
      gridNumPlaceholder: '占有されたグリッド数を入力してください',
      emptyWarning: '空にできません',
      integer: '整数でなければなりません。',
    },
    nextWarning:
      '現在の要素配置が異常です。確認してから次の操作を行ってください。',
    deleteMainWarningTitle: 'メインの要素グループを削除しますか',
    deleteMainWarningText:
      'この要素グループはレイアウトに追加されています。削除すると、プレイ可能な広告の正常な試用ができなくなる可能性があります。削除しますか？',
    elementSetting: {
      title: '外観',
      moveDirSelect: '移動方向の選択',
      forward: '直線',
      turnLeft: '左転回',
      turnRight: '右転回',
      left: '左折',
      right: '右折',
      backSetting: 'リバース設定',
      backSettingTip:
        'テストプレイ中に要素が逆移動をサポートしているかどうかを判断します。',
      turn: 'Uターン',
      noTurn: '後方へ',
      applyToAll: 'すべてに適用',
      reset: 'リセット',
    },
  },
  step3Editor: {
    title: '出口設定',
    titleTip: 'メイン要素に異なるタイプの出口を組み合わせてください',
    dialog: {
      title: '出口カテゴリを追加',
      categoryName: 'カテゴリ名',
      categoryNamePlaceholder: '入力',
      exitDir: '出口方向',
      exitDirTip: '対応する要素が出口から出ていく方向を決定してください',
      anyDir: '任意の方向',
      fixedDir: '固定方向',
      emptyWarning: '空にできません',
    },
    categoryTip:
      '動作中に要素を有効にするかどうかを決定します。無効にした場合、要素は無効になります。',
    selectImage: '画像を選択',
    selectArea: 'エリアを選択',
    area: 'エリア',
    bindEle: '対応要素',
    bindElePlaceholder: '選択してください',
    nextWarning: '先に{exit}に対応する要素を選択してください。',
  },
  sceneEditorTip:
    'ここをクリックすると、クイックレイアウトに入ることができます。',
  newGuide: {
    tip1: 'グリッド内に配置する要素をクリックして選択します。',
    tip2: 'レイアウトエリアで要素をクリックまたはスライドして配置します。',
    tip3: '要素をクリックして回転や移動ができます。また、キーボードの上下左右キーでも移動できます。',
    jump: 'スキップ',
    next: '次へ',
    know: '了解',
  },
  resourcePoolTip: '要素の頭が上を向いている画像を追加してください',
}
